import type { NextPage } from 'next';
import Image from 'next/image';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Brand } from '../../data/schema';
import { cdn } from 'data';

type Props = {
	brands: Brand[];
	onFilter: (brands: string[]) => void;
};

const BrandFilter = ({ brands, onFilter }: Props) => {
	const [showFilter, setShowFilter] = useState<boolean>(false);
	const [selectedBrands, setSelectedBrands] = useState<string[]>([]);

	useEffect(() => {
		onFilter(selectedBrands);
		console.log(selectedBrands, JSON.stringify(selectedBrands));
	}, [selectedBrands]);

	const brandsList = brands.map((brand) => {
		const className = [
			'text-gray-900 select-none hover:bg-green-600 hover:text-white relative py-2 pl-3 pr-9 cursor-pointer'
		];

		if (selectedBrands.includes(brand.id)) {
			className.push('bg-green-300');
		}

		return (
			<li
				key={brand.id}
				id={brand.id}
				role="option"
				aria-selected="true"
				className={className.join(' ')}
				onClick={() => {
					if (selectedBrands.includes(brand.id)) {
						setSelectedBrands(selectedBrands.filter((code) => code !== brand.id));
					} else {
						setSelectedBrands([...selectedBrands, brand.id]);
					}
				}}>
				<div className="flex items-center">
					<Image
						src={cdn(brand.logo)}
						className="flex-shrink-0 h-6 w-6 object-contain"
						alt={`Marcas de coches - Logo de ${brand.name}`}
						width={25}
						height={25}
						layout="fixed"
						priority={true}
					/>
					<span className="ml-3 block font-normal truncate">{brand.name}</span>
				</div>
			</li>
		);
	});

	let caret;

	if (showFilter) {
		caret = <FontAwesomeIcon icon={faCaretUp} className="w-4 h-4" />;
	} else {
		caret = <FontAwesomeIcon icon={faCaretDown} className="w-4 h-4" />;
	}

	return (
		<div className="m-3 relative">
			<button
				type="button"
				className="relative w-full bg-white rounded-md shadow-lg pl-3 pr-10 py-3 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
				onClick={() => setShowFilter(!showFilter)}>
				<span className="flex items-center">
					<span className="ml-3 block truncate">Filtrar marcas</span>
				</span>
				<span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
					{caret}
				</span>
			</button>
			{showFilter && (
				<div className="absolute mt-1 w-full z-10 rounded-md bg-white shadow-lg">
					<ul
						role="listbox"
						aria-labelledby="listbox-label"
						aria-activedescendant="listbox-item-3"
						className="max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
						{brandsList}
					</ul>
				</div>
			)}
		</div>
	);
};

export default BrandFilter;
